<h1 matDialogTitle>確認</h1>
<div mat-dialog-content>{{data?.messages}}</div>
<div mat-dialog-actions>
  <button mat-button [matDialogClose]="true">{{data?.true}}</button>
  <button mat-button [matDialogClose]="false">{{data?.false}}</button>
</div>
